import * as Yup from 'yup';

const defaultSchemaOptions = {
  name: Yup.string().required('Name is required'),
  companyName: Yup.string().required('Company is required'),
  jobTitle: Yup.string().required('Title is required'),
  email: Yup.string().email().required('Email is required'),
  phoneNumber: Yup.string(),
};

const schemaWithNumberOfUsersOptions = {
  ...defaultSchemaOptions,
  possibleNumberOfUsers: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string().required('Number of users is required'),
  }),
};

export const schema = () => Yup.object().shape(defaultSchemaOptions);
export const schemaWithNumberOfUsers = () => Yup.object().shape(schemaWithNumberOfUsersOptions);
